module.exports = __webpack_public_path__ + "img/edit.2c5097a5.svg";